export enum UserType {
	Doctor="DOCTOR", Patient="PATIENT",
}
